$(document).ready(function () {
  // Reusable waitForEl function using jQuery
  function waitForEl(selector, cb, attr, interval, timeout) {
    interval = interval || 100;
    timeout = timeout || 10000;
    let t = 0;
    const intv = setInterval(function () {
      const $el = $(selector);
      if ($el.length && (!attr || $el.attr(attr))) {
        clearInterval(intv);
        cb($el);
      } else if ((t += interval) >= timeout) {
        clearInterval(intv);
      }
    }, interval);
  }

  waitForEl('kaching-bundles-block', function ($el) {
    const deal = JSON.parse($el.attr('deal-block') || '{}');
    const product = JSON.parse($el.attr('product') || '{}');
    const config = JSON.parse($el.attr('config') || '{}');

    const { price, compareAtPrice } = product.variants[0];
    const priceDifference = ((compareAtPrice - price) / 100).toFixed(2);
    const priceDifferenceFormatted = config.moneyFormat
      .replace('{{amount}}', priceDifference)
      .replace('{{amount_with_comma_separator}}', priceDifference);

    // Only prevent clicks if NOT in Shopify customizer (which uses Shopify.designMode)
    if (!window.Shopify?.designMode) {
      $('.kaching-bundles__bar.kaching-bundles__bar--selected').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
      });
    }

    $.each(deal.dealBars || [], function (_, dealBar) {
      const $dealBar = $(`.kaching-bundles__bar[data-deal-bar-id="${dealBar.id}"]`);
      let giftsEdited = false;
      $.each(dealBar.freeGifts || [], function (giftIndex, gift) {
        const { id, text } = gift;
        const giftEl = $(`.kaching-bundles__bar:first-child [data-free-gift-id="${id}"]`);
        const giftImageSrc = giftEl.find('.kaching-bundles__free-gift__image').attr('src');
        const giftPrice = giftEl.find('.kaching-bundle-free').html();

        const giftBlock = $(`.kaching-bundle-gifts__item[data-index="${giftIndex + 1}"]`);
        if (giftBlock.length) {
          giftBlock.addClass('kaching-bundle-gifts__item--active');
          const imgEl = giftBlock.find('.kaching-bundle-gifts__image');
          if (giftImageSrc) imgEl.attr('src', giftImageSrc);

          giftBlock.find('.kaching-bundle-gifts__price').text(giftPrice);
          giftBlock.find('.kaching-bundle-gifts__item-title').text(text);
          giftEl.hide().find('+ .kaching-bundles__free-gift__divider').hide();
          giftsEdited = true;
        }
      });

      // Deal Bar Edits
      console.log("[Kaching Bundle Gifts] Deal Bar Element", $dealBar);

      // --- Benefits Section ---
      const benefitsList = ["Boosted Confidence", "Enhanced Stamina", "Stronger Wood"];
      const benefitSVG = `
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_257_14775)">
            <path d="M7 14.0029C5.72396 13.9847 4.55729 13.6748 3.5 13.0732C2.44271 12.4536 1.58593 11.5967 0.929688 10.5029C0.309896 9.39096 0 8.22429 0 7.00293C0 5.78157 0.309896 4.61491 0.929688 3.50293C1.58593 2.40917 2.44271 1.55241 3.5 0.932619C4.55729 0.331054 5.72396 0.0211589 7 0.00292969C8.27604 0.0211589 9.44274 0.331054 10.5 0.932619C11.5573 1.55241 12.4141 2.40917 13.0703 3.50293C13.6901 4.61491 14 5.78157 14 7.00293C14 8.22429 13.6901 9.39096 13.0703 10.5029C12.4141 11.5967 11.5573 12.4536 10.5 13.0732C9.44274 13.6748 8.27604 13.9847 7 14.0029ZM10.0898 5.71777C10.345 5.40787 10.345 5.09799 10.0898 4.78809C9.77996 4.53287 9.47004 4.53287 9.1602 4.78809L6.125 7.82324L4.83984 6.53809C4.52994 6.28287 4.22006 6.28287 3.91017 6.53809C3.65494 6.84799 3.65494 7.15787 3.91017 7.46777L5.66016 9.2178C5.97006 9.47295 6.27994 9.47295 6.58984 9.2178L10.0898 5.71777Z" fill="#1B4A26"/>
          </g>
          <defs>
            <clipPath id="clip0_257_14775">
              <rect width="14" height="14" fill="white"/>
            </clipPath>
          </defs>
        </svg>`;
      const $benefitsWrap = $(`<flex-wrap class="kaching-bundles__bar-benefits"></flex-wrap>`);
      benefitsList.forEach(text => $benefitsWrap.append(
        $(`<flex class="kaching-bundles__bar-benefit">${benefitSVG}<span>${text}</span></flex>`)
      ));
      $dealBar.find('.kaching-bundles__bar-content-left').append($benefitsWrap);

      // --- Prices Section ---
      const priceWrapper = $dealBar.find('.kaching-bundles__bar-pricing');
      const $priceGroup = $('<flex class="kaching-bundles__bar-price-group"></flex>');
      $priceGroup
        .append(priceWrapper.find('.kaching-bundles__bar-price'))
        .append(priceWrapper.find('.kaching-bundles__bar-full-price'));
      priceWrapper.append($priceGroup);

      const $priceDiff = $(`<info-box class="kaching-bundles__bar-price-difference">Save ${priceDifferenceFormatted}</info-box>`);
      priceWrapper.append($priceDiff);

      // --- Placement/Responsive Section ---
      const containerDesktop = $dealBar.find('.kaching-bundles__bar-content');
      const containerMobile = $dealBar.find('.kaching-bundles__bar-wrapper');
      const $kachingBundle = $('kaching-bundle').first();
      const $totalValue = $('.kaching-bundle-gifts__total-value').first();

      function setPricePlacement() {
        const w = window.innerWidth;
        if (w < 540 || (w > 1000 && w < 1280)) {
          containerMobile.append(priceWrapper, $totalValue);
        } else {
          containerDesktop.append(priceWrapper);
          if ($kachingBundle.length) $kachingBundle.after($totalValue);
        }
      }
      setPricePlacement();
      $totalValue.show();
      $(window).on('resize.kachingBundleGifts', setPricePlacement);

    });
  }, 'deal-block');
});